import { render } from "./ChatMenuTab.vue?vue&type=template&id=349c5a39"
import script from "./ChatMenuTab.vue?vue&type=script&lang=js"
export * from "./ChatMenuTab.vue?vue&type=script&lang=js"
script.render = render

export default script